import styled from 'styled-components';
import { Form } from 'antd';

export const Wrapper = styled.div`
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  max-width: 600px;
`;

export const StyledForm = styled(Form)`
  .ant-form-item {
    padding: 3px;
    margin-bottom: 0 !important;
  }

  .ant-space {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }
  td {
    padding: 8px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  a {
    padding: 8px;
    vertical-align: middle;
  }

  td:first-child {
    width: 150px;
    font-weight: 600;
    vertical-align: middle;
    border-right: 1px solid #ddd;
    background-color: #f8f8f8;
    padding-left: 15px;
  }
  input {
    padding: 7px 7px 7px 10px;
    width: 100%;
    margin: none;
  }
  select {
    padding: 9px;
    width: 100%;
  }
`;

export const TelInputGroup = styled.div`
  display: flex;
  align-items: center;
  padding: 3px;

  input {
    text-align: center;
    min-width: 60px;
  }

  span {
    margin: 0 10px;
    vertical-align: middle;
  }
`;

export const BizInputGroup = styled.div`
  display: flex;
  align-items: center;
  padding: 3px;

  input {
    text-align: center;
    min-width: 60px;
  }

  span {
    margin: 0 10px;
    vertical-align: middle;
  }
`;

export const StyledDownload = styled.a``;

export const BtnContainer = styled.div<{ isEditMode: boolean }>`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const StyledDivider = styled.div`
  font-size: 20px;
  margin: 15px 2px;
  font-weight: 500;
`;

export const FlexContainer = styled.div``;
